import {
    ComponentCategory,
    ComponentElementManifest
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import { DefaultLayoutId } from "@bizform/type/model/component_element/DefaultLayoutId.model";
import { PluginType } from "@bizform/type/model/model/Plugin.model";
import { ComponentElement } from "@bizform/type/model/component_element/ComponentElement.model";
import { FormStateKey } from "@bizform/type/model/form/FormStateKey.model";
import { ReactComponentElementInit } from "@bizform/core/dist/js/bizflow/core.min";
import { BfButton } from "../bf_component/button/BfButton";


/**
 * Button component element
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
export class BfFormAction extends BfButton {
    static readonly pluginType: string = PluginType.FORMACTIONHANDLER;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_ywGI0oucChedsEeTOcbr1FXNIuR_A3h",
        category: ComponentCategory.HANDLER,
        defaultLayoutId: DefaultLayoutId.ONLYCOMPONENTELEMENT,
        label: "Form Action Caller",
        description: "Form Action Caller",
        icon: "",
        property: null
    };

    @ReactComponentElementInit(BfFormAction)
    static init(): ComponentElement<string> {
        return;
    }

    _onClickEvent(e?: any): void {
        if (this.state.wrappedFormState && this.state.wrappedCompState.goToForm) {
            const linkForm = { [FormStateKey.LINKFORM]: this.state.wrappedCompState.goToForm };
            this.emitFormState(JSON.stringify(linkForm));
        }
    }
}
